import styled from "styled-components";

export const ReviewItemWrapper = styled.div<{ reduceTopPadding?: boolean }>(({ theme, reduceTopPadding }) => {
    return {
        padding: `0 ${theme.spacing.medium}`,
        width: "100%",
        marginTop: reduceTopPadding ? 0 : theme.spacing.medium,
        "& button:hover": {
            background: "none",
        },
    };
});
